"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverManagedSideBySideWidget = exports.SideBySideSelectionType = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var WidgetManager_1 = require("../../WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var DragGuidelines_1 = require("./DragGuidelines");
var SideBySideContext_1 = require("./SideBySideContext");
var SideBySideViewStore_1 = require("./SideBySideViewStore");
var SideBySide_2 = require("ContentTokens/Models/SideBySide");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var WithComplexWidgetHoverManager_1 = require("../WithComplexWidgetHoverManager");
var inversify_react_1 = require("inversify-react");
var SideBySideDivider_1 = require("./Divider/SideBySideDivider");
var useSelectionState_1 = require("Project/QwilrEditor/RegistryElement/useSelectionState");
var SideBySideSelectionType;
(function (SideBySideSelectionType) {
    SideBySideSelectionType["None"] = "None";
    SideBySideSelectionType["Outside"] = "Outside";
    SideBySideSelectionType["Around"] = "Around";
    SideBySideSelectionType["Inside"] = "Inside";
    SideBySideSelectionType["Full"] = "Full";
})(SideBySideSelectionType || (exports.SideBySideSelectionType = SideBySideSelectionType = {}));
var NAME = "side-by-side";
var SideBySideWidgetInner = (function (_super) {
    __extends(SideBySideWidgetInner, _super);
    function SideBySideWidgetInner(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSetPercentage = function (percentage) {
            if (_this.props.percent === percentage) {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SetPercentage,
                percentage: percentage,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleToggleOrder = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SwapOrder,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.viewStore = new SideBySideViewStore_1.SideBySideViewStore();
        _this.dragManager = _this.viewStore.dragManager;
        var containerRef = (0, react_1.createRef)();
        _this.dragManager.setDragContainer(containerRef, _this.handleSetPercentage);
        return _this;
    }
    SideBySideWidgetInner.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, children = _b.children, attributes = _b.attributes, selection = _b.selection, element = _b.element;
        var sideBySideFullySelected = selection === "circle";
        var isHovered = this.props.hoverManager.isHovered && !this.dragManager.isDragging && this.enableEditingControls;
        var hoverManagerHandlers = this.props.hoverManager.handlers;
        var width = element.data.width;
        return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, "side-by-side__wrapper"), onMouseEnter: hoverManagerHandlers.onMouseEnter, onMouseLeave: hoverManagerHandlers.onMouseLeave, onMouseDown: hoverManagerHandlers.onMouseMove }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(NAME, "".concat(NAME, "--widget"), "".concat(NAME, "--").concat(width), (_a = {},
                    _a["".concat(NAME, "--is-hovered")] = isHovered,
                    _a["".concat(NAME, "--is-dragging")] = this.dragManager.isDragging,
                    _a)), ref: this.dragManager.containerRef },
                react_1.default.createElement(SideBySideContext_1.SideBySideContext.Provider, { value: {
                        percent: this.props.percent,
                        placeholderIndex: this.props.placeholderIndex,
                        viewStore: this.viewStore,
                        isHovered: this.props.hoverManager.isHovered,
                    } }, react_1.default.Children.map(children, function (child, columnIdx) {
                    var isLeftCol = columnIdx === 0;
                    var columnName = isLeftCol ? "left" : "right";
                    var percent = _this.viewStore.dragManager.isDragging
                        ? _this.viewStore.dragManager.drawnDragPercentage
                        : _this.props.percent;
                    var columnPercent = isLeftCol ? percent : 100 - percent;
                    var style = _this.viewStore.dragManager.isDragging ? { width: "".concat(columnPercent, "%") } : {};
                    return (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side__col side-by-side__col--".concat(columnName), {
                                "side-by-side__col--one-quarter": columnPercent === SideBySide_2.SideBySideColumnSize.OneQuarter,
                                "side-by-side__col--one-half": columnPercent === SideBySide_2.SideBySideColumnSize.OneHalf,
                                "side-by-side__col--three-quarter": columnPercent === SideBySide_2.SideBySideColumnSize.ThreeQuarters,
                            }), style: style }, child),
                        isLeftCol && (react_1.default.createElement(SideBySideDivider_1.SideBySideDivider, { renderDragger: isHovered, forceShow: sideBySideFullySelected, isDragging: _this.viewStore.dragManager.isDragging, hideDragger: !!_this.viewStore.dragManager.snappedDragPercentage, renderSwapper: !_this.viewStore.dragManager.isDragging, onSwapperClick: _this.handleToggleOrder, onDragStart: function (evt) {
                                evt.stopPropagation();
                                evt.preventDefault();
                                _this.viewStore.dragManager.startDrag(evt.clientX);
                            } }))));
                })),
                react_1.default.createElement(DragGuidelines_1.DragGuidelines, { isVisible: this.dragManager.isDragging, allowedPercentageValues: SideBySide_1.AllowedPercentageValues, currentDragPercentage: this.dragManager.snappedDragPercentage, onGuidelineEnter: this.dragManager.onGuidelineHover, onGuidelineLeave: this.dragManager.onGuidelineLeave }))));
    };
    Object.defineProperty(SideBySideWidgetInner.prototype, "enableEditingControls", {
        get: function () {
            return this.props.widgetManager.canEdit;
        },
        enumerable: false,
        configurable: true
    });
    SideBySideWidgetInner = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], SideBySideWidgetInner);
    return SideBySideWidgetInner;
}(react_1.default.Component));
exports.HoverManagedSideBySideWidget = (0, WithComplexWidgetHoverManager_1.withComplexWidgetHoverManager)(SideBySideWidgetInner);
var SideBySideWidget = function (props) {
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var selection = (0, useSelectionState_1.useSelectionState)(props.element);
    return (react_1.default.createElement(exports.HoverManagedSideBySideWidget, __assign({}, props, { widgetManager: widgetManager, selection: selection.widgetSelectionState, enableResizing: false, percent: props.element.data.percent, placeholderIndex: props.element.data.placeholderIndex })));
};
exports.default = SideBySideWidget;
